import { Try } from "@/common";
import { IdType, PageDataType } from ".";
import { api } from "@/plugins";

export type User = {
  id: number;
  username: string;
  password: string;
  name: string;
  // organizations: OrgModel[];
  role: "USER" | "ADMIN" | "MANAGER";
  periodAt?: string;
  lastVisit?: string;
  createdAt: string;
  updatedAt: string;
  blockedAt?: string;
};

export interface CreateUser extends Omit<User, "id"> {
  passwordConfirmation: string;
}

export interface UpdateUser extends Partial<CreateUser> {}

export type UserPage = PageDataType<User>;

class UserService {
  @Try()
  async create(user: CreateUser) {
    const { data } = await api.post<IdType>("/user/", user);
    return data;
  }

  @Try()
  async page(query: string) {
    const { data } = await api.get<UserPage>(`/user/page?${query}`);

    return data;
  }

  @Try()
  async find(query: string = "") {
    const { data } = await api.get<PageDataType<User[]>>(`user?${query}`);
    return data;
  }

  @Try()
  async findByID(id: number) {
    const { data } = await api.get<User>(`user/${id}`);
    return data;
  }

  @Try()
  async update(id: number, user: Partial<User>) {
    await api.patch<User>(`user/${id}`, user);
    return true;
  }

  @Try()
  async delete(id: number) {
    await api.delete<User>(`user/${id}`);
    return true;
  }

  @Try()
  async findConsumption(id: number, query: string = "") {
    const { data } = await api.get(`/user/consumption/${id}?${query}`);
    return data;
  }
}

const userService = new UserService();

export { userService as UserService };
